const adjustHexAlpha = (color, opacity) => color + ("0" + Math.round(255 * opacity).toString(16)).slice(-2);
export default adjustHexAlpha;